<template>
  <div>
    <div class="support-page userpage-bg-fill userpage-bg-fill--vox bg-vox-populi bg-animation">
      <div class="d-flex min-vh-100 justify-content-center align-items-start py-3">
        <b-col md="20" class="mx-auto app-login-box">
          <div class="modal-dialog mx-auto support-dialog">
            <VueElementLoading :active="showLoading" spinner="ring" color="var(--primary)" />
            <div class="modal-content">
              <div class="modal-body">
                <div class="h5 modal-title text-center">
                  <br>
                  <v-img src="/images/logo_login.png" width="100%" height="138" contain align="center"></v-img>
                  <br>
                  <h4>
                    <div>{{ strings.title }}</div>
                  </h4>

                  <template v-if="!success">
                    <h6 class="mb-3 ml-3 mr3 text-left support-explanation">
                      <span>{{ strings.explanation }}</span>
                    </h6>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                        v-model="form.name"
                        :rules="nameRules"
                        :label="strings.nameLabel"
                        :placeholder="strings.namePlaceholder"
                        required
                      />
                      <v-text-field
                        v-model="form.email"
                        :rules="emailRules"
                        :label="strings.emailLabel"
                        :placeholder="strings.emailPlaceholder"
                        required
                      />
                      <v-text-field
                        v-model="form.phone"
                        :label="strings.phoneLabel"
                        :placeholder="strings.phonePlaceholder"
                      />
                      <v-text-field
                        v-model="form.title"
                        :rules="titleRules"
                        :label="strings.subjectLabel"
                        :placeholder="strings.subjectPlaceholder"
                        required
                      />
                      <v-textarea
                        v-model="form.content"
                        :rules="contentRules"
                        :label="strings.contentLabel"
                        :placeholder="strings.contentPlaceholder"
                        required
                        auto-grow
                        rows="4"
                      />
                    </v-form>
                  </template>

                  <div v-else class="alert alert-success mt-3 text-left" role="alert">
                    <strong>{{ strings.successLead }}</strong>
                    {{ strings.successRest }}
                  </div>
                </div>
              </div>
              <div v-if="!success" class="modal-footer clearfix">
                <div class="float-right">
                  <b-button
                    variant="primary"
                    size="lg"
                    :disabled="!canSubmit"
                    @click="submitRequest"
                  >
                    {{ strings.submit }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center text-white opacity-8 mt-3">Copyright &copy; Onikom Ltd</div>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
import AppService from "../services/app.service";
import VueElementLoading from "vue-element-loading";

function detectBrowserLocale() {
  const raw = (
    typeof navigator !== "undefined" &&
    (navigator.language || navigator.userLanguage || "")
  )
    .toLowerCase()
    .trim();
  if (raw.startsWith("bg")) {
    return "bg";
  }
  return "en";
}

const UI = {
  bg: {
    title: "Поддръжка",
    explanation:
      "Използвайте формата по-долу, за да се свържете с нашия екип. Полетата Име, E-mail, Тема и Съобщение са задължителни.",
    nameLabel: "Име",
    namePlaceholder: "Вашето име...",
    emailLabel: "E-mail",
    emailPlaceholder: "Вашият e-mail...",
    phoneLabel: "Телефон",
    phonePlaceholder: "Вашият телефон (по желание)...",
    subjectLabel: "Тема",
    subjectPlaceholder: "Кратка тема...",
    contentLabel: "Съобщение",
    contentPlaceholder: "Опишете проблема или въпроса...",
    successLead: "Съобщението е изпратено.",
    successRest: "Ще се свържем с вас възможно най-скоро.",
    submit: "Изпрати",
    required: "Полето е задължително",
    emailInvalid: "Невалиден e-mail",
  },
  en: {
    title: "Support",
    explanation:
      "Use the form below to contact our support team. Name, E-mail, Subject and Message are required fields.",
    nameLabel: "Name",
    namePlaceholder: "Your name...",
    emailLabel: "E-mail",
    emailPlaceholder: "Your email address...",
    phoneLabel: "Phone",
    phonePlaceholder: "Your phone number (optional)...",
    subjectLabel: "Subject",
    subjectPlaceholder: "Short subject...",
    contentLabel: "Message",
    contentPlaceholder: "Describe your issue or question...",
    successLead: "Your message has been sent.",
    successRest: "Our team will get back to you as soon as possible.",
    submit: "Send",
    required: "This field is required",
    emailInvalid: "Invalid email address",
  },
};

export default {
  name: "Support",
  components: {
    VueElementLoading,
  },
  data() {
    return {
      locale: detectBrowserLocale(),
      valid: true,
      success: false,
      showLoading: false,
      form: {
        title: "",
        content: "",
        name: "",
        email: "",
        phone: "",
      },
    };
  },
  computed: {
    strings() {
      return this.locale === "bg" ? UI.bg : UI.en;
    },
    nameRules() {
      const s = this.strings;
      return [(v) => !!(v && v.trim()) || s.required];
    },
    emailRules() {
      const s = this.strings;
      return [
        (v) => !!(v && v.trim()) || s.required,
        (v) => /.+@.+/.test(v || "") || s.emailInvalid,
      ];
    },
    titleRules() {
      const s = this.strings;
      return [(v) => !!(v && v.trim()) || s.required];
    },
    contentRules() {
      const s = this.strings;
      return [(v) => !!(v && v.trim()) || s.required];
    },
    canSubmit() {
      return (
        this.valid &&
        !!this.form.name.trim() &&
        !!this.form.email.trim() &&
        !!this.form.title.trim() &&
        !!this.form.content.trim()
      );
    },
  },
  methods: {
    submitRequest() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.showLoading = true;
      this.submitToApi()
        .then(() => {
          this.success = true;
        })
        .catch(() => {
          // reserved for API errors
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    submitToApi() {
      return AppService.requestFeedback({
        title: this.form.title.trim(),
        content: this.form.content.trim(),
        name: this.form.name.trim(),
        email: this.form.email.trim(),
        phone: this.form.phone.trim(),
      });
    },
  },
};
</script>

<style scoped>
.support-explanation span {
  font-weight: 400;
  line-height: 1.45;
}

.support-dialog {
  max-width: 720px;
  margin-top: 0;
  margin-bottom: 0;
}

@media (max-width: 576px) {
  .support-page .min-vh-100 {
    align-items: flex-start !important;
  }

  .support-dialog {
    width: calc(100vw - 1rem);
    max-width: calc(100vw - 1rem);
    margin-left: auto;
    margin-right: auto;
  }

  .support-dialog .modal-content {
    width: 100%;
    max-height: calc(100dvh - 1.5rem);
    display: flex;
    flex-direction: column;
  }

  .support-dialog .modal-body {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .support-dialog .modal-footer .float-right {
    float: none !important;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
